import { useSearchParams } from 'react-router'

import { NewPassword } from './new-password-form'

export default function NewPasswordPage() {
  const [searchParams] = useSearchParams()
  const oobCode = searchParams.get('oobCode')

  return <NewPassword oobCode={oobCode || ''} />
}
